import type { Coordinates, Size } from 'vue-advanced-cropper';

import type { ApiMethod } from '@/services/api.service';
import type { FileType, FileVersion } from '@/services/types/file.types';

export interface Metadata {
  image?: { coordinates: Coordinates; size: Size } | null;
  type: FileType;
}

// TODO: FileUploaderV2 cleanup
export enum ProcessorType {
  Multer = 1,
  Formidable = 2,
}

export interface SavingOptions {
  data?: unknown | null;
  file?: File | null; // TODO: FileUploaderV2 cleanup
  files?: File[] | null;
  image?: string | null; // TODO: FileUploaderV2 cleanup
  metadata?: Metadata | null;
  version: FileVersion;
}

export interface UploadingOptions {
  data?: unknown | null;
  file?: File | null; // TODO: FileUploaderV2 cleanup
  files?: File[] | null;
  image?: string | null; // TODO: FileUploaderV2 cleanup
  metadata?: Metadata | null;
  method?: ApiMethod; // TODO: FileUploaderV2 cleanup
  processorType?: ProcessorType; // TODO: FileUploaderV2 cleanup
  url: string;
}
